var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('ExpressFastOrdersEditAdmin',{attrs:{"EFO":_vm.EFO},on:{"saveExpressFastOrders":_vm.saveExpressFastOrders,"exportExpressFastOrders":_vm.exportExpressFastOrders}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }